//------------------------------------------------------------------------------------

import '../internal.scss';

import {
	CheckCircle,
	ChevronLeft,
	ChevronRight,
	Clear,
	Description,
	ExpandLess,
	ExpandMore,
	Refresh,
} from '../../../components/Icons/Icons';
import baseUrl, { userBaseUrl } from '../../../scripts/baseUrl';
import { useEffect, useRef, useState } from 'react';

import Buffer from '../../../components/Buffer/Buffer';
import Fallback from '../../../components/Fallback/Fallback';
import Footer from '../../../components/Footer/Footer';
import Header from '../../../components/Header/Header';
import Loading from '../../../components/Loading/Loading';
import Navigation from '../../../components/Navigation/Navigation';
import Pagination from '../../../components/Pagination/Pagination';
import auth from '../../../scripts/auth';
import axios from 'axios';
import calculateDateStatus from '../../../scripts/calculateDateStatus';
import filterVendorsByDepartment, {
	isCateringVendor,
} from '../../../scripts/filterVendorsByDepartment';
import filterVendorsByStation from '../../../scripts/filterVendorsByStation';
import hightlight from '../../../scripts/hightlighter';
import sortTable from '../../../scripts/sort';
import unauthorizedRedirection from '../../../scripts/unauthorizedRedirection';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { socket } from '../../../App';

// import { saveAs } from 'file-saver';

//------------------------------------------------------------------------------------

let searchTextField = '';

const Vendors = () => {
	unauthorizedRedirection();
	document.title = `Vendors â€¢ Bhusawal Division Catering Vendor Id`;

	const navigate = useNavigate();

	let accessToken =
		(localStorage.getItem('admin') == null ||
			localStorage.getItem('admin') == '') &&
		(localStorage.getItem('employee') != null ||
			localStorage.getItem('employee') != '')
			? JSON.parse(localStorage.getItem('employee')).accessToken
			: JSON.parse(localStorage.getItem('admin')).accessToken;

	const [vendors, setVendors] = useState([]);
	const [owner, setOwner] = useState('');
	const [notFound, setNotFound] = useState(true);
	const [buffer, setBuffer] = useState(true);
	const [loader, setLoader] = useState(false);
	const [isRefreshing, setIsRefreshing] = useState(false);
	const [fetchComplete, setFetchComplete] = useState(false);
	const [vendorAddStatus, setVendorAddStatus] = useState({
		added: {
			pfVendorCount: 0,
			stallTrolleyVendorCount: 0,
			supportingStaff: 0,
		},
		total: {
			pfVendorCount: 0,
			stallTrolleyVendorCount: 0,
			supportingStaff: 0,
		},
	});

	const [vendorsTotalItems, setVendorsTotalItems] = useState(0);
	const [vendorsItemsPerPage, setVendorsItemsPerPage] = useState(50);
	const [vendorsActivePage, setVendorsActivePage] = useState(1);

	const currentScreen = useLocation().pathname;
	const { state } = useLocation();

	// const [totalItems, setTotalItems] = useState(0);
	// const [itemsPerPage, setItemsPerPage] = useState(2);
	// const [activePage, setActivePage] = useState(1);

	const loggedInAdmin =
		localStorage.getItem('admin') != null && localStorage.getItem('admin') != ''
			? JSON.parse(localStorage.getItem('admin'))
			: null;
	const isSuperAdmin = loggedInAdmin && loggedInAdmin.superAdmin == 1;

	const [departmentView, setDepartmentView] = useState('All');

	const applyDepartmentView = (vendorsArray) => {
		if (!isSuperAdmin) return vendorsArray;
		if (departmentView === 'Catering') {
			return vendorsArray.filter((vendor) => isCateringVendor(vendor));
		}
		if (departmentView === 'Other') {
			return vendorsArray.filter((vendor) => !isCateringVendor(vendor));
		}
		return vendorsArray;
	};

	const selectDepartmentView = (view) => {
		setDepartmentView(view);
		setVendorsActivePage(1);
	};

	const getVendorAddStatus = async (ownerId) => {
		try {
			const res = await axios.get(
				`${userBaseUrl}/owners/vendorAddStatus/${ownerId}`,
				{
					headers: {
						'access-token': accessToken,
					},
				}
			);

			if (!auth(res.data.message)) return;

			if (res.data) {
				setVendorAddStatus((prev) => ({ ...prev, ...res.data }));
				setNotFound(false);
			} else {
				setNotFound(true);
			}
			setBuffer(false);
		} catch (err) {
			console.log(err);
		}
	};

	const getVendors = async () => {
		setIsRefreshing(true);

		if (currentScreen === '/owners/vendors') {
			const { ownerId, shopName } = state;
			setOwner(shopName);

			getVendorAddStatus(ownerId);

			try {
				const res = await axios.get(
					`${userBaseUrl}/vendors/${ownerId}`,
					{
						headers: {
							'access-token': accessToken,
						},
					}
				);

				console.log("vendor data ",res.data)

				if (!auth(res.data.message)) return;

				if (res.data) {
					if (res.data.length === 0) {
						alert(`Don't have any vendors under ${shopName}.`);
						navigate('/owners');
					}

					const arrayData = [];

					let vendorsArray =
						(localStorage.getItem('admin') == null ||
							localStorage.getItem('admin') == '') &&
						(localStorage.getItem('employee') != null ||
							localStorage.getItem('employee') != '')
							? filterVendorsByStation(res.data)
							: filterVendorsByDepartment(res.data);
					vendorsArray = applyDepartmentView(vendorsArray);

					for (const data of vendorsArray) {
						arrayData.unshift(data);
					}

					let array = arrayData;
					let mainArray = [];

					let n = 0;
					for (
						let i = 0;
						i < Math.ceil(array.length / vendorsItemsPerPage);
						i++
					) {
						mainArray.push([]);
						for (let a = 0; a < vendorsItemsPerPage; a++) {
							if (array[n] != undefined) {
								mainArray[i].push(array[n]);
								n++;
							}
						}
					}

					setVendors(mainArray);
					setVendorsTotalItems(res.data.length);

					setNotFound(false);
				} else {
					setNotFound(true);
				}
				setBuffer(false);
				setTimeout(() => {
					setTimeout(() => {
						setFetchComplete(false);
					}, 2000);
					setFetchComplete(true);
					setIsRefreshing(false);
				}, 1000);
			} catch (err) {
				console.log(err);
			}
		} else {
			setOwner('');
			try {
				const res = await axios.get(`${baseUrl}/vendors`, {
					headers: {
						'access-token': accessToken,
					},
				});

				if (!auth(res.data.message)) return;

				if (res.data) {
					const arrayData = [];

					let thisVendorsArray =
						(localStorage.getItem('admin') == null ||
							localStorage.getItem('admin') == '') &&
						(localStorage.getItem('employee') != null ||
							localStorage.getItem('employee') != '')
							? filterVendorsByStation(res.data)
							: filterVendorsByDepartment(res.data);
					thisVendorsArray = applyDepartmentView(thisVendorsArray);

					// for (const data of thisVendorsArray) {
					// 	arrayData.unshift(data);
					// }
					// setVendors([...arrayData]);

					for (const data of thisVendorsArray) {
						arrayData.unshift(data);
					}

					let array = arrayData;
					let mainArray = [];

					let n = 0;
					for (
						let i = 0;
						i < Math.ceil(array.length / vendorsItemsPerPage);
						i++
					) {
						mainArray.push([]);
						for (let a = 0; a < vendorsItemsPerPage; a++) {
							if (array[n] != undefined) {
								mainArray[i].push(array[n]);
								n++;
							}
						}
					}

					setVendors(mainArray);
					setVendorsTotalItems(res.data.length);

					setNotFound(false);

					setTimeout(() => {
						setTimeout(() => {
							setFetchComplete(false);
						}, 2000);
						setFetchComplete(true);
						setIsRefreshing(false);
					}, 1000);
				} else {
					setNotFound(true);
				}
				setBuffer(false);
			} catch (err) {
				console.log(err);
			}
		}
	};

	useEffect(() => {
		getVendors();

		socket.on('isVendorUpdated', (data) => {
			if (searchTextField.length === 0) {
				getVendors();
			}
		});

		socket.on('isOwnerUpdated', (data) => {
			if (searchTextField.length === 0) {
				getVendors();
			}
		});

		// let callData = setInterval(() => {
		//     getVendors();
		// }, 1000 * 5);

		// return () => {
		//     clearInterval(callData);
		// }

		// setTimeout(() => {
		//     const searchInput = document.getElementById('search-input');
		//     const onEnter = document.getElementById('on-enter');
		//     searchInput.addEventListener("keypress", function (event) {
		//         if (event.key === "Enter") {
		//             event.preventDefault();
		//             onEnter.click();
		//         }
		//     });
		// }, 500);
	}, []);

	const isFirstDepartmentRender = useRef(true);

	useEffect(() => {
		if (isFirstDepartmentRender.current) {
			isFirstDepartmentRender.current = false;
			return;
		}
		getVendors();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [departmentView]);

	const sort = async (table, column, order) => {
		setLoader(true);
		let thisArray = await sortTable(table, column, order);
		// const arrayData = [];
		// for (const data of array) {
		// 	arrayData.unshift(data);
		// }
		// setVendors([...arrayData]);
		if (currentScreen === '/owners/vendors') {
			const arrayData = [];

			let vendorsArray =
				(localStorage.getItem('admin') == null ||
					localStorage.getItem('admin') == '') &&
				(localStorage.getItem('employee') != null ||
					localStorage.getItem('employee') != '')
					? filterVendorsByStation(thisArray)
					: filterVendorsByDepartment(thisArray);
			vendorsArray = applyDepartmentView(vendorsArray);

			for (const data of vendorsArray) {
				arrayData.unshift(data);
			}

			let array = arrayData;
			let mainArray = [];

			let n = 0;
			for (
				let i = 0;
				i < Math.ceil(array.length / vendorsItemsPerPage);
				i++
			) {
				mainArray.push([]);
				for (let a = 0; a < vendorsItemsPerPage; a++) {
					if (array[n] != undefined) {
						mainArray[i].push(array[n]);
						n++;
					}
				}
			}

			setVendors(mainArray);
			setVendorsTotalItems(thisArray.length);
		} else {
			const arrayData = [];

			let thisVendorsArray =
				(localStorage.getItem('admin') == null ||
					localStorage.getItem('admin') == '') &&
				(localStorage.getItem('employee') != null ||
					localStorage.getItem('employee') != '')
					? filterVendorsByStation(thisArray)
					: filterVendorsByDepartment(thisArray);
			thisVendorsArray = applyDepartmentView(thisVendorsArray);

			// for (const data of thisVendorsArray) {
			// 	arrayData.unshift(data);
			// }
			// setVendors([...arrayData]);

			for (const data of thisVendorsArray) {
				arrayData.unshift(data);
			}

			let array = arrayData;
			let mainArray = [];

			let n = 0;
			for (
				let i = 0;
				i < Math.ceil(array.length / vendorsItemsPerPage);
				i++
			) {
				mainArray.push([]);
				for (let a = 0; a < vendorsItemsPerPage; a++) {
					if (array[n] != undefined) {
						mainArray[i].push(array[n]);
						n++;
					}
				}
			}

			setVendors(mainArray);
			setVendorsTotalItems(thisArray.length);
		}
		setLoader(false);
	};

	const [searchText, setSearchText] = useState({
		search: '',
	});

	const handleChange = (e) => {
		setSearchText((prev) => ({ ...prev, search: e.target.value }));
	};

	const search = async () => {
		if (searchText.search.length !== 0 && searchText.search.length < 255) {
			let searchUrl = '';

			if (currentScreen === '/owners/vendors') {
				const { ownerId, shopName } = state;
				searchUrl = `${baseUrl}/vendors-under-this-owner/search/${ownerId}`;
			} else {
				searchUrl = `${baseUrl}/vendors/search`;
			}

			try {
				setNotFound(true);
				setBuffer(true);
				const res = await axios.post(searchUrl, searchText, {
					headers: {
						'access-token': accessToken,
					},
				});

				if (!auth(res.data.message)) return;

				if (res.data) {
					if (res.data.length === 0) {
						setNotFound(false);
						setBuffer(false);
						setTimeout(() => {
							alert(`No results for "${searchText.search}".`);
						}, 10);
						return;
					}

					// const arrayData = [];
					// for (const data of res.data) {
					// 	arrayData.unshift(data);
					// }
					// setVendors([...arrayData]);
					if (currentScreen === '/owners/vendors') {
						const arrayData = [];

						let vendorsArray =
							(localStorage.getItem('admin') == null ||
								localStorage.getItem('admin') == '') &&
							(localStorage.getItem('employee') != null ||
								localStorage.getItem('employee') != '')
								? filterVendorsByStation(res.data)
								: filterVendorsByDepartment(res.data);
						vendorsArray = applyDepartmentView(vendorsArray);

						for (const data of vendorsArray) {
							arrayData.unshift(data);
						}

						let array = arrayData;
						let mainArray = [];

						let n = 0;
						for (
							let i = 0;
							i < Math.ceil(array.length / vendorsItemsPerPage);
							i++
						) {
							mainArray.push([]);
							for (let a = 0; a < vendorsItemsPerPage; a++) {
								if (array[n] != undefined) {
									mainArray[i].push(array[n]);
									n++;
								}
							}
						}

						setVendors(mainArray);
						setVendorsTotalItems(res.data.length);
					} else {
						const arrayData = [];

						let thisVendorsArray =
							(localStorage.getItem('admin') == null ||
								localStorage.getItem('admin') == '') &&
							(localStorage.getItem('employee') != null ||
								localStorage.getItem('employee') != '')
								? filterVendorsByStation(res.data)
								: filterVendorsByDepartment(res.data);
						thisVendorsArray = applyDepartmentView(thisVendorsArray);

						// for (const data of thisVendorsArray) {
						// 	arrayData.unshift(data);
						// }
						// setVendors([...arrayData]);

						for (const data of thisVendorsArray) {
							arrayData.unshift(data);
						}

						let array = arrayData;
						let mainArray = [];

						let n = 0;
						for (
							let i = 0;
							i < Math.ceil(array.length / vendorsItemsPerPage);
							i++
						) {
							mainArray.push([]);
							for (let a = 0; a < vendorsItemsPerPage; a++) {
								if (array[n] != undefined) {
									mainArray[i].push(array[n]);
									n++;
								}
							}
						}

						setVendors(mainArray);
						setVendorsTotalItems(res.data.length);
					}
					setNotFound(false);
				} else {
					setNotFound(true);
				}
				setBuffer(false);
				searchTextField = searchText.search;
				hightlight(searchTextField);

				// setSearchText((prev) => ({ ...prev, search: '' }));
				// searchTextField = searchText.search;
			} catch (err) {
				console.log(err);
			}
		} else if (
			searchText.search.length !== 0 &&
			searchText.search.length > 255
		) {
			alert('Search text is too big to search.');
		} else {
			alert("Can't search, search field is empty.");
		}
	};

	//---------------------------------------------------------

	const [dialog, setDialog] = useState(false);
	const [dialogIndex, setDialogIndex] = useState(0);

	const fetchVendorQr = async (vendorId) => {
		try {
			const res = await axios.get(`${baseUrl}/vendors/qr/${vendorId}`, {
				headers: { 'access-token': accessToken },
			});
			setDialog((prev) =>
				prev && prev.id === vendorId ? { ...prev, qr: res.data.qr } : prev
			);
		} catch (err) {
			console.log(err);
		}
	};

	const openDialog = (index) => {
		const globalIndex = (vendorsActivePage - 1) * vendorsItemsPerPage + index;
		const vendor = vendors[vendorsActivePage - 1][index];
		setDialogIndex(globalIndex);
		setDialog(vendor);
		setIsEditingVendor(false);
		setEditFiles({});
		fetchVendorQr(vendor.id);
	};

	const closeDialog = () => {
		setDialog(false);
		setIsEditingVendor(false);
		setEditFiles({});
	};

	const allVendorsFlat = vendors.flat();

	const findNextEnabledIndex = (fromIndex, direction) => {
		let index = fromIndex + direction;
		while (
			index >= 0 &&
			index < allVendorsFlat.length &&
			allVendorsFlat[index].isDisabled == '1'
		) {
			index += direction;
		}
		return index >= 0 && index < allVendorsFlat.length ? index : -1;
	};

	const hasPrevVendor = findNextEnabledIndex(dialogIndex, -1) !== -1;
	const hasNextVendor = findNextEnabledIndex(dialogIndex, 1) !== -1;

	const navigateVendor = (direction) => {
		const nextIndex = findNextEnabledIndex(dialogIndex, direction);
		if (nextIndex === -1) return;
		const vendor = allVendorsFlat[nextIndex];
		setDialogIndex(nextIndex);
		setDialog(vendor);
		setIsEditingVendor(false);
		setEditFiles({});
		fetchVendorQr(vendor.id);
	};

	//---------------------------------------------------------

	const [isEditingVendor, setIsEditingVendor] = useState(false);
	const [editForm, setEditForm] = useState({});
	const [editFiles, setEditFiles] = useState({});
	const [savingVendor, setSavingVendor] = useState(false);
	const [designationOptions, setDesignationOptions] = useState([]);
	const [stationOptions, setStationOptions] = useState([]);

	const getDesignationOptions = async () => {
		try {
			const res = await axios.get(`${baseUrl}/designations/vendors`, {
				headers: { 'access-token': accessToken },
			});
			if (Array.isArray(res.data)) setDesignationOptions(res.data);
		} catch (err) {
			console.log(err);
		}
	};

	const getStationOptions = async () => {
		try {
			const res = await axios.get(`${baseUrl}/stations`);
			if (Array.isArray(res.data)) setStationOptions(res.data);
		} catch (err) {
			console.log(err);
		}
	};

	const startEditVendor = () => {
		setEditForm({
			fullname: dialog.fullname || '',
			aadhaar: dialog.aadhaar || '',
			idNumber: dialog.idNumber || '',
			desigination: dialog.desigination || '',
			station: dialog.station || '',
			unit: dialog.unit || '',
			issueDate: dialog.issueDate || '',
			validUpto: dialog.validUpto || '',
			validFor: dialog.validFor || '',
		});
		setEditFiles({});
		if (designationOptions.length === 0) getDesignationOptions();
		if (stationOptions.length === 0) getStationOptions();
		setIsEditingVendor(true);
	};

	const cancelEditVendor = () => {
		setIsEditingVendor(false);
		setEditFiles({});
	};

	const handleEditFormChange = (e) => {
		setEditForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
	};

	const handleEditFileChange = (e) => {
		const { name, files } = e.target;
		if (files && files[0]) {
			setEditFiles((prev) => ({ ...prev, [name]: files[0] }));
		}
	};

	const vendorDocumentUploadRoutes = {
		medicalReport: {
			path: 'medical',
			field: 'medicalFile',
		},
		policeVerification: {
			path: 'police',
			field: 'policeFile',
		},
		otherDocument1: {
			path: 'other1',
			field: 'otherFile1',
		},
		otherDocument2: {
			path: 'other2',
			field: 'otherFile2',
		},
	};

	const saveVendorEdits = async () => {
		setSavingVendor(true);
		try {
			await axios.put(
				`${userBaseUrl}/vendors/details/${dialog.id}`,
				editForm,
				{ headers: { 'access-token': accessToken } }
			);

			const uploadTasks = [];

			if (editFiles.photo) {
				const formData = new FormData();
				formData.append('image', editFiles.photo);
				uploadTasks.push(
					axios.put(
						`${userBaseUrl}/vendors/${dialog.id}`,
						formData,
						{ headers: { 'access-token': accessToken } }
					)
				);
			}

			for (const key of Object.keys(vendorDocumentUploadRoutes)) {
				if (!editFiles[key]) continue;
				const { path, field } = vendorDocumentUploadRoutes[key];
				const formData = new FormData();
				formData.append(field, editFiles[key]);
				uploadTasks.push(
					axios.put(
						`${userBaseUrl}/vendors/${path}/${dialog.id}`,
						formData,
						{ headers: { 'access-token': accessToken } }
					)
				);
			}

			await Promise.all(uploadTasks);

			setIsEditingVendor(false);
			setEditFiles({});
			closeDialog();
			getVendors();
			socket.emit('updateVendors', { message: 'updateVendors' });
		} catch (err) {
			console.log(err);
			alert('Failed to update vendor. Please try again.');
		}
		setSavingVendor(false);
	};

	// const getRemainingDays = (endingDate) => {
	//     const date1 = new Date();
	//     const date2 = new Date(endingDate);
	//     const diffTime = Math.abs(date2 - date1);
	//     const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

	//     if ((date2 - date1).toString()[0] == '-') {
	//         return {
	//             className: 'warning-container strong',
	//             label: `Vendor's validity expired ${diffDays - 1} days ago.`,
	//         };
	//     }

	//     if (diffDays < 1) {
	//         return {
	//             className: 'warning-container strong',
	//             label: `Vendor's validity expired.`,
	//         };
	//     }

	//     if (diffDays < 15) {
	//         return {
	//             className: 'warning-container strong',
	//             label: `${diffDays} days remaining.`,
	//         };
	//     }

	//     return {
	//         className: 'warning-container',
	//         label: `${diffDays} days remaining.`,
	//     };
	// }

	const disableVendor = async (vendorId, vendorName, isEmployee) => {
		if (!isEmployee) {
			let accessToken = JSON.parse(
				localStorage.getItem('admin')
			).accessToken;

			if (
				window.confirm(
					`Are you sure you want to deactivate this vendor with name '${vendorName}'? This process is non-reversal.`
				)
			) {
				// if (
				//     window.prompt(
				//         `Enter vendor name '${vendorName}' to deactivate.`
				//     ) !== vendorName
				// ) {
				//     alert('Wrong input. Vendor not deactivated');
				//     return;
				// }

				try {
					setNotFound(true);
					setBuffer(true);
					let data = {
						updatedBy: 'admins',
						updaterId: JSON.parse(localStorage.getItem('admin')).id,
					};
					// const res = await axios.put(
					// 	`${userBaseUrl}/vendors/disable/${vendorId}`,
					// 	data,
					// 	{
					// 		headers: {
					// 			'access-token': accessToken,
					// 		},
					// 	}
					// );

					const res = await axios.delete(
						`${userBaseUrl}/vendors/delete/${vendorId}`,
						data,
						{
							headers: {
								'access-token': accessToken,
							},
						}
					);

					if (!auth(res.data.message)) return;

					if (res.data) {
						getVendors();
						setNotFound(false);

						socket.emit('updateVendors', {
							message: 'updateVendors',
						});
					} else {
						setNotFound(true);
					}
					setBuffer(false);
					console.log("delete success");
				} catch (err) {
					console.log(err);
				}
			}
		} else {
			let accessToken = JSON.parse(
				localStorage.getItem('employee')
			).accessToken;

			if (
				window.confirm(
					`Are you sure you want to deactivate this vendor with name '${vendorName}'? This process is non-reversal.`
				)
			) {
				try {
					setNotFound(true);
					setBuffer(true);
					let data = {
						updatedBy: 'employees',
						updaterId: JSON.parse(localStorage.getItem('employee'))
							.id,
					};
					// const res = await axios.put(
					// 	`${userBaseUrl}/vendors/disable/${vendorId}`,
					// 	data,
					// 	{
					// 		headers: {
					// 			'access-token': accessToken,
					// 		},
					// 	}
					// );

					const res = await axios.delete(
						`${userBaseUrl}/vendors/delete/${vendorId}`,
						data,
						{
							headers: {
								'access-token': accessToken,
							},
						}
					);

					if (!auth(res.data.message)) return;

					if (res.data) {
						getVendors();
						setNotFound(false);

						socket.emit('updateVendors', {
							message: 'updateVendors',
						});
					} else {
						setNotFound(true);
					}
					setBuffer(false);
					console.log("delete success");
				} catch (err) {
					console.log(err);
				}
			}
		}
	};

	const deleteVendor = async (vendorId, vendorName, isEmployee) => {
		try {
		  const userType = isEmployee ? 'employee' : 'admin';
		  const user = JSON.parse(localStorage.getItem(userType));
		  const accessToken = user?.accessToken;
	  
		  if (!accessToken) {
			alert('Authentication error. Please log in again.');
			window.location.href = '/login'; // Redirect to login page
			return;
		  }
	  
		  if (
			!window.confirm(
			  `Are you sure you want to delete the vendor '${vendorName}'? This process is irreversible.`
			)
		  ) {
			return;
		  }
	  
		  // Define the data to be sent
		  const data = {
			updatedBy: isEmployee ? 'employees' : 'admins',
			updaterId: user.id,
		  };
	  
		  // Send delete request
		  const response = await axios.delete(
			`${userBaseUrl}/vendors/delete/${vendorId}`,
			{
			  headers: {
				'access-token': accessToken,
			  },
			  data, // Pass data as part of the request body
			}
		  );
	  
		  if (response?.data) {
			alert(`Vendor '${vendorName}' deleted successfully.`);
			getVendors(); // Refresh the vendor list
			socket.emit('updateVendors', {
			  message: 'updateVendors',
			});
		  } else {
			alert('Failed to delete the vendor. Please try again.');
		  }
		} catch (error) {
		  if (error.response?.status === 401) {
			alert('Session expired. Please log in again.');
			window.location.href = '/login'; // Redirect to login on auth failure
		  } else {
			console.error('Error deleting vendor:', error);
			alert('An unexpected error occurred. Please try again later.');
		  }
		}
	  };


	// pagination
	// const getPageNumber = (activePageNumber) => {
	//     setActivePage(activePageNumber);
	// }

	const getPageNumberVendors = (number) => {
		setVendorsActivePage(number);
	};

	const enterClick = (e) => {
		if (e.key === 'Enter' || e.keyCode === 13) {
			let button = document.getElementById('on-enter');
			button.click();
		}
	};

	// const generateAndDownloadIDCard = async (vendor) => {
	//     closeDialog();
	//     setLoader(true);

	//     axios.get(`${baseUrl}/generate-vendor-pdf/${vendor.id}`, { responseType: 'blob' })
	//         .then((res) => {
	//             if (res.data.message == false) {
	//                 alert("Can't generate ID card. Vendor may be not activated or disabled.");
	//                 return;
	//             }

	//             const pdfBlob = new Blob([res.data], { type: 'application/pdf' });

	//             saveAs(pdfBlob, `${vendor.fullname} (${vendor.unit}).pdf`);
	//             setLoader(false);
	//         });
	// }

	// const totalCount = () => {
	// 	let count = 0;
	// 	for (let i = 0; i < vendors.length; i++) {
	// 		count = count + vendors[i].length;
	// 	}
	// 	return count;
	// };

	useEffect(() => {
		document.addEventListener('keyup', (e) => {
			if (e.key !== '/') return;
			let searchInput = document.getElementById('search-input');
			searchInput.focus();
		});
	}, []);

	const getVendorStatusMeta = (vendor) => {
		if (!vendor) return { label: '', tone: '' };
		if (vendor.isDisabled == '1') {
			return { label: 'Deactivated', tone: 'tone-error' };
		}
		return { label: 'Active', tone: 'tone-success' };
	};

	const formatDialogDate = (date) => {
		if (!date) return '--';
		const d = new Date(date);
		return `${d.getDate()}-${d.getMonth() + 1}-${d.getFullYear()}`;
	};

	const vendorStatusMeta = getVendorStatusMeta(dialog);

	const documentFields = [
		{ key: 'medicalReport', label: 'Medical report' },
		{ key: 'policeVerification', label: 'Police Verification' },
		{ key: 'otherDocument1', label: 'Aadhaar card' },
		{ key: 'otherDocument2', label: 'Other Document2' },
	];

	return (
		<>
			<Header />
			<div className='screen-container'>
				<Navigation />
				<div className='side-container'>
					{buffer && notFound ? <Buffer /> : <></>}

					{vendors.length === 0 && !buffer ? (
						<Fallback
							title='Not found'
							text='No data found in the database. Try refreshing the page.'
						/>
					) : (
						<></>
					)}

					{vendors.length !== 0 && !notFound && !buffer ? (
						<>
							<div className='screen-title headline-large'>
								{owner ? `Vendors (${owner})` : `Vendors`}
							</div>
							{currentScreen === '/owners/vendors' && (
								<button
									type='button'
									className='text-button back-button'
									onClick={() => navigate('/owners')}
								>
									<ChevronLeft />
									Back to Contractors
								</button>
							)}
							{isSuperAdmin && (
								<div className='department-tabs'>
									{['All', 'Catering', 'Other'].map(
										(view) => (
											<button
												key={view}
												type='button'
												className={
													departmentView === view
														? 'department-tab active'
														: 'department-tab'
												}
												onClick={() =>
													selectDepartmentView(view)
												}
											>
												{view}
											</button>
										)
									)}
								</div>
							)}
							{currentScreen === '/owners/vendors' && (
								<div className='active-vendors-counts-container'>
									<div className='active-vendors-counts'>
										<div className='value headline-large'>
											{
												vendorAddStatus.added
													.stallTrolleyVendorCount
											}
											<span>
												/
												{
													vendorAddStatus.total
														.stallTrolleyVendorCount
												}
											</span>
										</div>
										<div className='title title-small'>
											Number of staff
										</div>
									</div>
									<div className='active-vendors-counts'>
										<div className='value headline-large'>
											{
												vendorAddStatus.added
													.pfVendorCount
											}
											<span>
												/
												{
													vendorAddStatus.total
														.pfVendorCount
												}
											</span>
										</div>
										<div className='title title-small'>
											PF vendor
										</div>
									</div>
									<div className='active-vendors-counts'>
										<div className='value headline-large'>
											{
												vendorAddStatus.added
													.supportingStaff
											}
											<span>
												/
												{
													vendorAddStatus.total
														.supportingStaff
												}
											</span>
										</div>
										<div className='title title-small'>
											Supporting staff
										</div>
									</div>
									<div className='active-vendors-counts total'>
										<div className='value headline-large'>
											{vendorAddStatus.added
												.stallTrolleyVendorCount +
												vendorAddStatus.added
													.pfVendorCount +
												vendorAddStatus.added
													.supportingStaff}
											<span>
												/
												{vendorAddStatus.total
													.stallTrolleyVendorCount +
													vendorAddStatus.total
														.pfVendorCount +
													vendorAddStatus.total
														.supportingStaff}
											</span>
										</div>
										<div className='title title-small'>
											Total vendors
										</div>
									</div>
								</div>
							)}
							{/* {currentScreen !== '/owners/vendors' && ( */}
							<div className='search-container'>
								<input
									type='text'
									className='body-medium'
									id='search-input'
									name='search'
									onChange={handleChange}
									placeholder='Search here (press "/" to focus)'
									onKeyUp={(event) => enterClick(event)}
									defaultValue={searchText.search}
								/>
								<button
									disabled={isRefreshing}
									className={
										isRefreshing
											? 'icon-button refreshing'
											: 'icon-button'
									}
									onClick={() => {
										searchTextField = '';
										setSearchText((prev) => ({
											...prev,
											search: '',
										}));

										document.getElementById(
											'search-input'
										).value = '';

										getVendors();
									}}
									title='Reload'
								>
									{fetchComplete ? (
										<CheckCircle />
									) : (
										<Refresh />
									)}
								</button>
								<button
									type='button'
									id='on-enter'
									className='filled-tonal-button'
									onClick={search}
								>
									Search
								</button>
							</div>
							{/* )} */}

							<div className='table-container center'>
								<table>
									<thead>
										<tr>
											<th className='left-box'>
												<div className='table-head'>
													<div className='table-title'>
														Sr.&nbsp;No.
													</div>
												</div>
											</th>
											<th>
												<div className='table-head'>
													<div className='table-title'>
														Photo
													</div>
												</div>
											</th>
											{/* <th>
                                                    <div className='table-head'>
                                                        <div className='table-title'>Photo</div>
                                                    </div>
                                                </th> */}

											<th>
												<div className='table-head'>
													<div className='table-title'>
														Full&nbsp;name
													</div>
													{(localStorage.getItem(
														'admin'
													) != null ||
														localStorage.getItem(
															'admin'
														) != '') &&
														(localStorage.getItem(
															'employee'
														) == null ||
															localStorage.getItem(
																'employee'
															) == '') &&
														currentScreen !==
															'/owners/vendors' && (
															<div className='sort-container'>
																<button
																	className='sort-button'
																	title='Sort by ascending order'
																	onClick={() =>
																		sort(
																			'vendors',
																			'fullname',
																			'ASC'
																		)
																	}
																>
																	<ExpandLess />
																</button>
																<button
																	className='sort-button'
																	title='Sort by descending order'
																	onClick={() =>
																		sort(
																			'vendors',
																			'fullname',
																			'DESC'
																		)
																	}
																>
																	<ExpandMore />
																</button>
															</div>
														)}
												</div>
											</th>

											{/* <th>
                                                    <div className='table-head'>
                                                        <div className='table-title'>Vendor Type</div>
                                                    </div>
                                                </th> */}

											{/* <th>
                                                <div className='table-head'>
                                                    <div className='table-title'>Aadhaar&nbsp;number</div>
                                                    {
                                                        currentScreen !== '/owners/vendors' &&
                                                        <div className='sort-container'>
                                                            <button className='sort-button' onClick={() => sort('vendors', 'aadhaar', 'ASC')}><ExpandLess /></button>
                                                            <button className='sort-button' onClick={() => sort('vendors', 'aadhaar', 'DESC')}><ExpandMore /></button>
                                                        </div>
                                                    }
                                                </div>
                                            </th>

                                            <th>
                                                <div className='table-head'>
                                                    <div className='table-title'>Id&nbsp;number</div>
                                                    {
                                                        currentScreen !== '/owners/vendors' &&
                                                        <div className='sort-container'>
                                                            <button className='sort-button' onClick={() => sort('vendors', 'idNumber', 'ASC')}><ExpandLess /></button>
                                                            <button className='sort-button' onClick={() => sort('vendors', 'idNumber', 'DESC')}><ExpandMore /></button>
                                                        </div>
                                                    }
                                                </div>
                                            </th>

                                            <th>
                                                <div className='table-head'>
                                                    <div className='table-title'>Designation</div>
                                                </div>
                                            </th>

                                            <th>
                                                <div className='table-head'>
                                                    <div className='table-title'>Unit</div>
                                                </div>
                                            </th>

                                            <th>
                                                <div className='table-head'>
                                                    <div className='table-title'>Date&nbsp;of&nbsp;issue</div>
                                                    {
                                                        currentScreen !== '/owners/vendors' &&
                                                        <div className='sort-container'>
                                                            <button className='sort-button' onClick={() => sort('vendors', 'issueDate', 'ASC')}><ExpandLess /></button>
                                                            <button className='sort-button' onClick={() => sort('vendors', 'issueDate', 'DESC')}><ExpandMore /></button>
                                                        </div>
                                                    }
                                                </div>
                                            </th>

                                            <th>
                                                <div className='table-head'>
                                                    <div className='table-title'>Valid&nbsp;upto</div>
                                                    {
                                                        currentScreen !== '/owners/vendors' &&
                                                        <div className='sort-container'>
                                                            <button className='sort-button' onClick={() => sort('vendors', 'validUpto', 'ASC')}><ExpandLess /></button>
                                                            <button className='sort-button' onClick={() => sort('vendors', 'validUpto', 'DESC')}><ExpandMore /></button>
                                                        </div>
                                                    }
                                                </div>
                                            </th>

                                            <th>
                                                <div className='table-head'>
                                                    <div className='table-title'>Valid&nbsp;for</div>
                                                </div>
                                            </th> */}

											{/* <th>
                                                <div className='table-head'>
                                                    <div className='table-title'>Owner&nbsp;Id</div>
                                                    {
                                                        currentScreen !== '/owners/vendors' &&
                                                        <div className='sort-container'>
                                                            <button className='sort-button' onClick={() => sort('vendors', 'ownerId', 'ASC')}><ExpandLess /></button>
                                                            <button className='sort-button' onClick={() => sort('vendors', 'ownerId', 'DESC')}><ExpandMore /></button>
                                                        </div>
                                                    }
                                                </div>
                                            </th> */}

											<th>
												<div className='table-head'>
													<div className='table-title'>
														Firm&nbsp;name
													</div>
													{(localStorage.getItem(
														'admin'
													) != null ||
														localStorage.getItem(
															'admin'
														) != '') &&
														(localStorage.getItem(
															'employee'
														) == null ||
															localStorage.getItem(
																'employee'
															) == '') &&
														currentScreen !==
															'/owners/vendors' && (
															<div className='sort-container'>
																<button
																	className='sort-button'
																	title='Sort by ascending order'
																	onClick={() =>
																		sort(
																			'vendors',
																			'unit',
																			'ASC'
																		)
																	}
																>
																	<ExpandLess />
																</button>
																<button
																	className='sort-button'
																	title='Sort by descending order'
																	onClick={() =>
																		sort(
																			'vendors',
																			'unit',
																			'DESC'
																		)
																	}
																>
																	<ExpandMore />
																</button>
															</div>
														)}
												</div>
											</th>

											<th>
												<div className='table-head'>
													<div className='table-title'>
														Designation
													</div>
													{(localStorage.getItem(
														'admin'
													) != null ||
														localStorage.getItem(
															'admin'
														) != '') &&
														(localStorage.getItem(
															'employee'
														) == null ||
															localStorage.getItem(
																'employee'
															) == '') &&
														currentScreen !==
															'/owners/vendors' && (
															<div className='sort-container'>
																<button
																	className='sort-button'
																	title='Sort by ascending order'
																	onClick={() =>
																		sort(
																			'vendors',
																			'desigination',
																			'ASC'
																		)
																	}
																>
																	<ExpandLess />
																</button>
																<button
																	className='sort-button'
																	title='Sort by descending order'
																	onClick={() =>
																		sort(
																			'vendors',
																			'desigination',
																			'DESC'
																		)
																	}
																>
																	<ExpandMore />
																</button>
															</div>
														)}
												</div>
											</th>

											<th>
												<div className='table-head'>
													<div className='table-title'>
														Station
													</div>
													{(localStorage.getItem(
														'admin'
													) != null ||
														localStorage.getItem(
															'admin'
														) != '') &&
														(localStorage.getItem(
															'employee'
														) == null ||
															localStorage.getItem(
																'employee'
															) == '') &&
														currentScreen !==
															'/owners/vendors' && (
															<div className='sort-container'>
																<button
																	className='sort-button'
																	title='Sort by ascending order'
																	onClick={() =>
																		sort(
																			'vendors',
																			'station',
																			'ASC'
																		)
																	}
																>
																	{/* <ExpandLess /> */}
																</button>
																<button
																	className='sort-button'
																	title='Sort by descending order'
																	onClick={() =>
																		sort(
																			'vendors',
																			'station',
																			'DESC'
																		)
																	}
																>
																	{/* <ExpandMore /> */}
																</button>
															</div>
														)}
												</div>
											</th>


											{/* {
                                                    (localStorage.getItem('admin') != null || localStorage.getItem('admin') != '')
                                                    && (localStorage.getItem('employee') == null || localStorage.getItem('employee') == '')
                                                    && */}
											<th>
												<div className='table-head'>
													<div className='table-title'>
														Vendor&nbsp;status
													</div>
													{(localStorage.getItem(
														'admin'
													) != null ||
														localStorage.getItem(
															'admin'
														) != '') &&
														(localStorage.getItem(
															'employee'
														) == null ||
															localStorage.getItem(
																'employee'
															) == '') &&
														currentScreen !==
															'/owners/vendors' && (
															<div className='sort-container'>
																<button
																	className='sort-button'
																	title='Sort by ascending order'
																	onClick={() =>
																		sort(
																			'vendors',
																			'isDisabled',
																			'ASC'
																		)
																	}
																>
																	<ExpandLess />
																</button>
																<button
																	className='sort-button'
																	title='Sort by descending order'
																	onClick={() =>
																		sort(
																			'vendors',
																			'isDisabled',
																			'DESC'
																		)
																	}
																>
																	<ExpandMore />
																</button>
															</div>
														)}
												</div>
											</th>
											{/* } */}

											<th className='right-box'>
												<div className='table-head'>
													<div className='table-title'>
														View
													</div>
												</div>
											</th>
										</tr>
									</thead>
									{vendors[vendorsActivePage - 1]?.map(
										(vendor, index) => {
											let className =
												vendor.isDisabled == '1'
													? 'disabled-row'
													: '';
											let dotClassName = 'dot';

											if (vendor.isDisabled == '0') {
												className = 'success-row';
												dotClassName = 'dot success';
											}
											// console.log("vendor in return ",vendor)
											return (
												
												<tbody
													// key={`vendor-${vendor.id}`}
													key={Math.random()}
													title={`${vendor.fullname} (${vendor.station})`}
												>
													<tr className='gap'></tr>
													<tr className={className}>
														<td
															className='center left-box'
															onClick={() => {
																if (
																	vendor.isDisabled ==
																	'0'
																) {
																	openDialog(
																		index
																	);
																}
															}}
														>
															<div
																className={
																	dotClassName
																}
															></div>
															{(vendorsActivePage -
																1) *
																vendorsItemsPerPage +
																(index + 1)}
														</td>
														{/* <td className='img hover' >{vendor.photo && <img src={vendor.photo} />}</td> */}
														<td
															onClick={() => {
																if (
																	vendor.isDisabled ==
																	'0'
																) {
																	openDialog(
																		index
																	);
																}
															}}
														>
															<div className='table-profile-photo'>
																<img
																	src={
																		vendor.photo
																	}
																/>
															</div>
														</td>
														<td
															className='hightlight'
															onClick={() => {
																if (
																	vendor.isDisabled ==
																	'0'
																) {
																	openDialog(
																		index
																	);
																}
															}}
														>
															{vendor.fullname ||
																'Unknown'}{' '}
															{vendor.addedByAdmin !=
															0 ? (
																<div className='added-by-admin'>
																	(Added by
																	Admin)
																</div>
															) : (
																''
															)}
														</td>
														<td
															className='hightlight'
															onClick={() => {
																if (
																	vendor.isDisabled ==
																	'0'
																) {
																	openDialog(
																		index
																	);
																}
															}}
														>
															{vendor.unit ||
																'Unknown'}
														</td>
														<td
															className='hightlight'
															onClick={() => {
																if (
																	vendor.isDisabled ==
																	'0'
																) {
																	openDialog(
																		index
																	);
																}
															}}
														>
															{vendor.desigination ||
																'Unknown'}
														</td>
														<td
															className='hightlight'
															onClick={() => {
																if (
																	vendor.isDisabled ==
																	'0'
																) {
																	openDialog(
																		index
																	);
																}
															}}
														>
															{vendor.station ||
																'Unknown'}
														</td>
														{/* <td>{vendor.vendorType || 'Unknown'}</td> */}
														{/* <td>{vendor.aadhaar || 'Unknown'}</td>
                                                            <td>{vendor.idNumber || 'Unknown'}</td>
                                                            <td>{vendor.desigination || 'Unknown'}</td>
                                                            <td>{vendor.unit || 'Unknown'}</td>
                                                            <td>{vendor.issueDate || 'Unknown'}</td>
                                                            <td>{vendor.validUpto || 'Unknown'}</td>
                                                            <td>{vendor.validFor || 'Unknown'}</td> */}
														{/* <td>{vendor.ownerId || 'Unknown'}</td> */}

														{/* if admin */}
														{(localStorage.getItem(
															'admin'
														) != null ||
															localStorage.getItem(
																'admin'
															) != '') &&
															(localStorage.getItem(
																'employee'
															) == null ||
																localStorage.getItem(
																	'employee'
																) == '') && (
																<td
																	className='hover center'
																	onClick={() => {
																		if (
																			vendor.isDisabled ==
																			'0'
																		) {
																			// disableVendor(
																			// 	vendor.id,
																			// 	vendor.fullname,
																			// 	false
																			// );
																			deleteVendor(
																				vendor.id,
																				vendor.fullname,
																				false
																			);
																		}
																	}}
																>
																	{vendor.isDisabled ==
																	0 ? (
																		<button className='text-button'>
																			{/* Click
																			to 
																			 {/* deactivate 
																			 delete */}

																			 click to delete
																		</button>
																	) : (
																		'Deactivated'
																	)}
																</td>
															)}

														{/* if employee */}
														{(localStorage.getItem(
															'admin'
														) == null ||
															localStorage.getItem(
																'admin'
															) == '') &&
															(localStorage.getItem(
																'employee'
															) != null ||
																localStorage.getItem(
																	'employee'
																) != '') && (
																<td
																	className='hover center'
																	onClick={() => {
																		if (
																			vendor.isDisabled ==
																			'0'
																		) {
																			// disableVendor(
																			// 	vendor.id,
																			// 	vendor.fullname,
																			// 	true
																			// );
																			deleteVendor(
																				vendor.id,
																				vendor.fullname,
																				false
																			);
																		}
																	}}
																>
																	{vendor.isDisabled ==
																	0 ? (
																		<button className='text-button'>
																			click to delete
																		</button>
																	) : (
																		'Deactivated'
																	)}
																</td>
															)}

														<td
															className='hover right-box'
															onClick={() => {
																if (
																	vendor.isDisabled ==
																	'0'
																) {
																	openDialog(
																		index
																	);
																}
															}}
														>
															<button className='text-button'>
																View vendor
															</button>
														</td>
													</tr>
												</tbody>
											);
										}
									)}
								</table>
							</div>
							{/* <Pagination
								getTotalItems={vendorsTotalItems}
								getItemsPerPage={vendorsItemsPerPage}
								getPageNumber={getPageNumberVendors}
								activePage={vendorsActivePage}
							/> */}
							{/* <Pagination getTotalItems={totalItems} getItemsPerPage={itemsPerPage} getPageNumber={getPageNumber} activePage={activePage} /> */}
							
						</>
					) : (
						<></>
					)}
					<Pagination getTotalItems={vendorsTotalItems} getItemsPerPage={vendorsItemsPerPage} getPageNumber={getPageNumberVendors} activePage={vendorsActivePage} />
					<Footer />
				</div>
			</div>

			{dialog && (
				<div className='dialog-container'>
					<dialog
						open
						className='dialog vendor-details-dialog'
					>
						<div className='dialog-top'>
							<div className='dialog-top-info'>
								<div className='title title-large'>
									Vendor details
								</div>
								<div
									className={`status-chip ${vendorStatusMeta.tone}`}
								>
									{vendorStatusMeta.label}
								</div>
							</div>
							{!isEditingVendor && (
								<button
									className='outlined-button'
									onClick={startEditVendor}
								>
									Edit
								</button>
							)}
							<button
								className='icon-button'
								onClick={closeDialog}
							>
								<Clear />
							</button>
						</div>

						<div className='dialog-content'>
						{isEditingVendor ? (
							<div className='vendor-edit-form'>
								<div className='vendor-edit-photo'>
									<div className='profile-image'>
										<img
											className='img'
											src={
												editFiles.photo
													? URL.createObjectURL(
															editFiles.photo
													  )
													: dialog.photo
											}
											alt=''
										/>
									</div>
									<label className='outlined-button file-input-label'>
										Change photo
										<input
											type='file'
											accept='image/*'
											name='photo'
											hidden
											onChange={handleEditFileChange}
										/>
									</label>
								</div>

								<div className='label label-medium'>
									Full name
								</div>
								<input
									className='inputfield'
									name='fullname'
									value={editForm.fullname}
									onChange={handleEditFormChange}
								/>

								<div className='label label-medium'>
									Aadhaar number
								</div>
								<input
									className='inputfield'
									name='aadhaar'
									value={editForm.aadhaar}
									onChange={handleEditFormChange}
								/>

								<div className='label label-medium'>
									Id number
								</div>
								<input
									className='inputfield'
									name='idNumber'
									value={editForm.idNumber}
									onChange={handleEditFormChange}
								/>

								<div className='label label-medium'>
									Designation
								</div>
								<select
									className='inputfield'
									name='desigination'
									value={editForm.desigination}
									onChange={handleEditFormChange}
								>
									<option value={editForm.desigination}>
										{editForm.desigination}
									</option>
									{designationOptions
										.filter(
											(item) =>
												item.designation !==
												editForm.desigination
										)
										.map((item, index) => (
											<option
												key={index}
												value={item.designation}
											>
												{item.designation}
											</option>
										))}
								</select>

								<div className='label label-medium'>
									Station
								</div>
								<select
									className='inputfield'
									name='station'
									value={editForm.station}
									onChange={handleEditFormChange}
								>
									<option value={editForm.station}>
										{editForm.station}
									</option>
									{stationOptions
										.filter(
											(item) =>
												item.station !==
												editForm.station
										)
										.map((item, index) => (
											<option
												key={index}
												value={item.station}
											>
												{item.station}
											</option>
										))}
								</select>

								<div className='label label-medium'>
									Unit / Firm name
								</div>
								<input
									className='inputfield'
									name='unit'
									value={editForm.unit}
									onChange={handleEditFormChange}
								/>

								<div className='label label-medium'>
									Date of issue
								</div>
								<input
									type='date'
									className='inputfield'
									name='issueDate'
									value={editForm.issueDate}
									onChange={handleEditFormChange}
								/>

								<div className='label label-medium'>
									Valid upto
								</div>
								<input
									type='date'
									className='inputfield'
									name='validUpto'
									value={editForm.validUpto}
									onChange={handleEditFormChange}
								/>

								<div className='label label-medium'>
									Valid for platform
								</div>
								<input
									className='inputfield'
									name='validFor'
									value={editForm.validFor}
									onChange={handleEditFormChange}
								/>

								<div className='section-heading label-medium'>
									Documents
								</div>
								<div className='vendor-edit-documents'>
									{documentFields.map(({ key, label }) => (
										<div
											className='vendor-edit-document-item'
											key={key}
										>
											<div className='label label-medium'>
												{label}
											</div>
											<div className='body-medium'>
												{editFiles[key]
													? editFiles[key].name
													: dialog[key]
													? 'Current file uploaded'
													: 'Not uploaded'}
											</div>
											<label className='outlined-button file-input-label'>
												Replace
												<input
													type='file'
													name={key}
													hidden
													onChange={
														handleEditFileChange
													}
												/>
											</label>
										</div>
									))}
								</div>

								<div className='dialog-buttons-container'>
									<button
										className='outlined-button'
										disabled={savingVendor}
										onClick={cancelEditVendor}
									>
										Cancel
									</button>
									<button
										className='filled-button'
										disabled={savingVendor}
										onClick={saveVendorEdits}
									>
										{savingVendor
											? 'Savingâ€¦'
											: 'Save changes'}
									</button>
								</div>
							</div>
						) : (
						<>
							<div className='vendor-hero'>
								<div className='container-1 qr-image-container'>
									<div className='profile-image'>
										<img
											className='img'
											src={dialog.photo}
											alt=''
										/>
									</div>
									{(localStorage.getItem('admin') != null ||
										localStorage.getItem('admin') != '') &&
										(localStorage.getItem('employee') ==
											null ||
											localStorage.getItem(
												'employee'
											) == '') && (
											<div className='qr-column'>
												<img
													className='qr-image'
													src={dialog.qr}
													alt=''
												/>
												<div className='vendor-nav-buttons'>
													<button
														className='icon-button'
														onClick={() =>
															navigateVendor(-1)
														}
														disabled={!hasPrevVendor}
														title='Previous vendor'
													>
														<ChevronLeft />
													</button>
													<button
														className='icon-button'
														onClick={() =>
															navigateVendor(1)
														}
														disabled={!hasNextVendor}
														title='Next vendor'
													>
														<ChevronRight />
													</button>
												</div>
											</div>
										)}
								</div>

								<div className='vendor-identity'>
									<div className='vendor-name title-large'>
										{dialog.fullname || 'Unknown'}
									</div>
									<div className='vendor-meta body-large'>
										{[dialog.desigination, dialog.unit]
											.filter(Boolean)
											.join(' â€¢ ')}
									</div>
									{dialog.station && (
										<div className='vendor-station-chip label-medium'>
											{dialog.station}
										</div>
									)}
								</div>
							</div>

							{(localStorage.getItem('admin') != null ||
								localStorage.getItem('admin') != '') &&
								(localStorage.getItem('employee') == null ||
									localStorage.getItem('employee') == '') &&
								(JSON.parse(localStorage.getItem('admin'))
									.superAdmin == 1 ||
									JSON.parse(localStorage.getItem('admin'))
										.permissions === 'f3d0a2a4') && (
									<div className='dialog-buttons-container'>
										<a
											href={dialog.qr}
											download={`${dialog.fullname} (${dialog.unit}) QR`}
										>
											<button className='filled-tonal-button'>
												Download QR
											</button>
										</a>
									</div>
								)}

							<div
								className={
									calculateDateStatus(dialog.validUpto)
										.className
								}
							>
								{calculateDateStatus(dialog.validUpto).message}
							</div>

							<div className='section-heading label-medium'>
								Documents
							</div>
							<div className='documents-row'>
								{documentFields.map(({ key, label }) => (
									<div
										className='document-item'
										key={key}
									>
										{dialog[key] ? (
											<a
												rel='noopener noreferrer'
												href={dialog[key]}
												target='_blank'
											>
												<button className='outlined-button'>
													<Description />
													{label}
												</button>
											</a>
										) : (
											<button
												className='outlined-button'
												disabled
											>
												<Description />
												{label} not found
											</button>
										)}
									</div>
								))}
							</div>

							<div className='section-heading label-medium'>
								Vendor information
							</div>
							<div className='info-grid'>
								<div className='info-item'>
									<div className='info-label label-medium'>
										Full name
									</div>
									<div className='info-value body-large'>
										{dialog.fullname}
									</div>
								</div>

								<div className='info-item'>
									<div className='info-label label-medium'>
										Aadhaar number
									</div>
									<div className='info-value body-large'>
										{dialog.aadhaar}
									</div>
								</div>

								<div className='info-item'>
									<div className='info-label label-medium'>
										Id number
									</div>
									<div className='info-value body-large'>
										{dialog.idNumber}
									</div>
								</div>

								<div className='info-item'>
									<div className='info-label label-medium'>
										Designation
									</div>
									<div className='info-value body-large'>
										{dialog.desigination}
									</div>
								</div>

								<div className='info-item'>
									<div className='info-label label-medium'>
										Unit
									</div>
									<div className='info-value body-large'>
										{dialog.unit}
									</div>
								</div>

								<div className='info-item'>
									<div className='info-label label-medium'>
										Station
									</div>
									<div className='info-value body-large'>
										{dialog.station
											? dialog.station
											: '--'}
									</div>
								</div>

								<div className='info-item info-row-triple'>
									<div>
										<div className='info-label label-medium'>
											Date of issue
										</div>
										<div className='info-value body-large'>
											{formatDialogDate(dialog.issueDate)}
										</div>
									</div>

									<div>
										<div className='info-label label-medium'>
											Valid upto
										</div>
										<div className='info-value body-large'>
											{formatDialogDate(dialog.validUpto)}
										</div>
									</div>

									<div>
										<div className='info-label label-medium'>
											Valid for platform
										</div>
										<div className='info-value body-large'>
											{dialog.validFor}
										</div>
									</div>
								</div>
							</div>
						</>
						)}
						</div>
					</dialog>
				</div>
			)}

			{loader && <Loading />}
		</>
	);
};

export default Vendors;

//------------------------------------------------------------------------------------
